import { Modal, Tutorial, Utils } from 'common';

const { TutorialPosition } = Tutorial;
const { ModalButtonActionType } = Modal;
const { Logger, Session, Util } = Utils;

export default [
	{
		title: 'Welcome!',
		message: `<p>You can use the <b>Products</b> page to set up shipping preferences for individual products.</p></br><p>Product names and SKUs automatically appear as you import orders from stores.</p></br><p>Supplement or override that information to speed up your shipping process.</p></br><p>Click <b>Next</b> to get started.</p>`,
		width: 550,
		position: TutorialPosition.Center,
	},
	{
		title: 'Add Products Manually',
		message: `<p>Set up products before they import and we'll apply your preferences to new orders containing those products.</p>`,
		width: 300,
		element: '.add-new-product-toolbar-button',
		position: TutorialPosition.Bottom,
		showArrow: true,
	},
	{
		title: 'Add Categories',
		message: `<p>Sort your products into groups (clothing, accessories, home, etc.) accessible from the left panel.</p>`,
		width: 400,
		element: '.categories-toolbar-button',
		position: TutorialPosition.Bottom,
		showArrow: true,
	},
	{
		title: 'Learn More',
		message: `<p>Note that changes to product preferences won't apply retroactively&mdash; they'll apply to new orders that import with those products.</p></br><p>If you still have questions or want to learn about advanced features, click <b>Learn More</b>.</p></br><p>Otherwise, click <b>Close</b> to get started.</p>`,
		width: 552,
		position: TutorialPosition.Center,
		buttons: [
			{
				text: 'Close',
				type: ModalButtonActionType.End,
			},
			{
				text: 'Learn More',
				onClick: () => {
					Util.openHelpCenter('20821062888347');

					Logger.logToServer({
						category: 'tutorial_info',
						action: 'learn_more',
					});
				},
			},
		],
	},
];
